<mat-expansion-panel [expanded]="false">
  <mat-expansion-panel-header>
    <mat-panel-title class="bold">
      {{ 'common.labels.filters' | transloco }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="_filterForm" class="padding">

    @if (isAdmin) {
      <div class="flex">
        <mat-radio-group formControlName="orderMessageIsReadByAdmin" class="flex-item">
          <mat-radio-button [value]="false">{{ 'messageListFilter.unread' | transloco }}</mat-radio-button>
          <mat-radio-button [value]="true">{{ 'common.labels.read' | transloco }}</mat-radio-button>
        </mat-radio-group>
      </div>
    }

    @if (!isAdmin) {
      <div class="flex">
        <mat-radio-group formControlName="orderMessageIsReadByClient" class="flex-item">
          <mat-radio-button [value]="false">{{ 'messageListFilter.unread' | transloco }}</mat-radio-button>
          <mat-radio-button [value]="true">{{ 'common.labels.read' | transloco }}</mat-radio-button>
        </mat-radio-group>
      </div>
    }

    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'messageListFilter.referenceNumber' | transloco }}</mat-label>
        <input matInput [formControlName]="'referenceNumber'" [placeholder]="'messageListFilter.referenceNumber' | transloco" />
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'messageListFilter.messageContains' | transloco }}</mat-label>
        <input matInput [formControlName]="'orderMessageText'" [placeholder]="'messageListFilter.messageContains' | transloco" />
      </mat-form-field>
      @if (isAdmin) {
        <mat-form-field class="form-field flex-item">
          <mat-label>{{ 'messageListFilter.corporation' | transloco }}</mat-label>
          <mat-select [formControlName]="'corporationID'" (selectionChange)="onCorporationChanged($event)">
            <mat-option [value]="null">{{ 'messageListFilter.all' | transloco }}</mat-option>
            @for (option of _corporations; track option) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (!isAdmin || _userGroups.length > 0) {
        <mat-form-field class="form-field flex-item">
          <mat-label>{{ 'messageListFilter.userGroup' | transloco }}</mat-label>
          <mat-select [formControlName]="'userGroupID'" (selectionChange)="onUserGroupChanged($event)">
            <mat-option [value]="null">{{ 'messageListFilter.all' | transloco }}</mat-option>
            @for (option of _userGroups; track option) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (_users.length > 0) {
        <mat-form-field class="form-field flex-item">
          <mat-label>{{ 'messageListFilter.user' | transloco }}</mat-label>
          <mat-select [formControlName]="'userID'">
            <mat-option [value]="null">{{ 'messageListFilter.all' | transloco }}</mat-option>
            @for (option of _users; track option) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>

    <div class="spacer-small"></div>
    <div>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
        (click)="onClear()" [disabled]="!_filterForm.dirty">
        {{ 'common.labels.clearFilters' | transloco }}
      </button>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
        (click)="onFilter()">
        {{ 'common.labels.filter' | transloco }}
      </button>
    </div>
  </form>
</mat-expansion-panel>